var $701c918a4653e946$exports = {};
$701c918a4653e946$exports = {
    "Clear search": `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`
};


export {$701c918a4653e946$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
